import moment from 'moment';
import axios from 'axios';
import $ from 'jquery';
import { push } from 'redux-little-router';

export const changeTab = (index) => {
  return {
    type: 'CHANGE_TAB',
    index: index
  };
}
// export function onChangeTab(index) {
//   return (dispatch, getState) => {
//     dispatch(changeTab(index));
//   }
// }

export const sortResults = (sort) => {
  return {
    type: 'SORT_RESULTS',
    sort: sort
  };
}

export const searched = (bool) => {
  return {
    type: 'SEARCHED',
    bool: bool
  };
}
// export const clickAd = (id) => {
//   return {
//     type: 'CLICK_AD',
//     bool: bool
//   };
// }
export function onClickAd() {
  // console.log('clicked');
  return (dispatch, getState) => {
    const { ad } = getState().brc;
    $.post("https://brc-stage.herokuapp.com/api/banner_clicked", {
      showId: ad.showId,
      adId: ad.id
    }, function (data) {
      // console.log(data);
    }, 'json');
    // axios.post('/banner_clicked', {
    //   showId: ad.showId,
    //   adId: ad.id
    // });
    // dispatch(clickAd());
  }
}

export const toggleMenu = (bool) => {
  return {
    type: 'TOGGLE_MENU',
    bool: bool
  };
}
export function onToggleMenu(bool) {
  return (dispatch, getState) => {
    dispatch(changeTab(bool));
  }
}

export const toggleHelp = (bool) => {
  return {
    type: 'TOGGLE_HELP',
    bool: bool
  };
}
export function onToggleHelp(bool) {
  return (dispatch, getState) => {
    dispatch(toggleHelp(bool));
  }
}

export const setWindowSize = (w, h) => {
  return {
    type: 'SET_WINDOW_SIZE',
    wW: w,
    wH: h
  };
}
export function onSetWindowSize(w, h) {
  return (dispatch, getState) => {
    dispatch(setWindowSize(w, h));
  }
}

export const showResults = (bool) => {
  return {
    type: 'SHOW_RESULTS',
    bool: bool
  };
}
export function onShowResults(bool) {
  return (dispatch, getState) => {
    dispatch(showResults(bool));
  }
}

export const showDetail = (bool) => {
  return {
    type: 'SHOW_DETAIL',
    bool: bool
  };
}
export function onShowDetail(bool) {
  return (dispatch, getState) => {
    if (!!!bool) {
      const { mapOptions } = getState().brc;
      var url = '/' + mapOptions.center.lat + '/' + mapOptions.center.lng + '/' + mapOptions.zoom;
      dispatch(push(url));
    }
    dispatch(showDetail(bool));
  }
}

export const showInfo = (bool) => {
  return {
    type: 'SHOW_INFO',
    bool: bool
  };
}
export function onShowInfo(bool) {
  return (dispatch, getState) => {
    dispatch(showInfo(bool));
  }
}

export const searchInProgress = (bool) => {
  return {
    type: 'SEARCH_IN_PROGRESS',
    bool: bool
  };
}
export function onSearchInProgress(bool) {
  return (dispatch, getState) => {
    dispatch(searchInProgress(bool));
  }
}

export const slideCarousel = (id) => {
  return {
    type: 'SLIDE_CAROUSEL',
    id: id
  };
}
export function onSlideCarousel(id) {
  return (dispatch, getState) => {
    dispatch(slideCarousel(id));
  }
}

export const expandMap = (bool) => {
  return {
    type: 'EXPAND_MAP',
    bool: bool
  };
}
export function onExpandMap(bool) {
  return (dispatch, getState) => {
    dispatch(expandMap(bool));
  }
}

export const showGlobalAlert = (bool) => {
  return {
    type: 'SHOW_GLOBAL_ALERT',
    bool: bool
  };
}
export function onShowGlobalAlert() {
  return (dispatch, getState) => {
    const { clusters } = getState().brc;
    var timeframe = moment().subtract(8, 'days'), clusterStatus = [];

    clusters.forEach((item, index) => {
      var markerCount = 0, NSCount = 0;
      item.points.forEach(point => {
        markerCount++;
        var isNS = false;
        var date = point.grade_updated;
        if (point.dry_grade || point.wet_grade) {
          if (moment(date).isBefore(timeframe)) {
            isNS = true;
          }
        }
        if (isNS) NSCount++;
      });
      var percentNS = NSCount / markerCount;
      clusterStatus.push(percentNS);
    });
    var average = clusterStatus.reduce((p, c) => p + c, 0) / clusterStatus.length;
    if (average > 0.5) {
      dispatch(showGlobalAlert(true));
    } else {
      dispatch(showGlobalAlert(false));
    }
  }
}

export const userClosedNSMessage = (bool) => {
  return {
    type: 'USER_CLOSED_NS_MESSAGE',
    bool: bool
  };
}
export function onUserClosedNSMessage(bool) {
  return (dispatch, getState) => {
    dispatch(userClosedNSMessage(bool));
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/ui.js